import { useMediaQuery } from '@intigral/hooks';
import { Button, CameraPhone, FlexWrapper, FontIcon, Text } from '@intigral/shared';
import { FlexChild } from '@intigral/shared/components/FlexWrapper';
import { useMemo } from 'react';
import QRCode from 'react-qr-code';
import h from '../../../../helpers/common';
import { __ } from '../../../../translations';
import { REDEEM_QUEST_TYPE } from '../../constants';
import { QRPopupProps } from '../../types/iGamification';
import { Modal } from '../../../../components/ui/Modal';

const QRPopup = ({ openQRModal, setOpenQRModal, rewardType }: QRPopupProps) => {
    const isMobile = useMediaQuery('(max-width: 924px)');

    const deepLinkUrl = useMemo(() => {
        switch (rewardType) {
            case REDEEM_QUEST_TYPE.TVOD:
                return h.getAppDeepLinkUrlTvodRent();
            case REDEEM_QUEST_TYPE.UPGRADE:
                return h.getAppDeepLinkUrlTierUpgrade();
            default:
                return '';
        }
    }, [rewardType]);

    const handleClose = () => {
        if (isMobile) setOpenQRModal(false);
    };

    if (!openQRModal) return null;

    return (
        <Modal
            useFlexLayout={false}
            open={openQRModal}
            onOpenChange={handleClose}
            closePlacement="null"
            widthSet="medium"
        >
            <FlexWrapper
                flexDirection="column"
                justifyContent="center"
                gap="2x"
                paddingTop={isMobile ? '3x' : undefined}
            >
                <FlexChild alignSelf="center">
                    {isMobile ? <FontIcon size="medium" name="info" /> : <CameraPhone />}
                </FlexChild>

                <Text as="h3" variant="h5" margin="0">
                    {isMobile ? __('quests_redeem_app_qr_modal_title') : __('quests_redeem_qr_modal_title')}
                </Text>

                {!isMobile && (
                    <FlexChild alignSelf="center">
                        <QRCode
                            id="QRCodeScaled"
                            size={256}
                            style={{
                                height: 'auto',
                                maxWidth: '100%',
                                width: '100%',
                                padding: 'calc(var(--step) * 3)',
                                borderRadius: 'var(--step)',
                                backgroundColor: '#fff',
                            }}
                            value={deepLinkUrl}
                            viewBox="0 0 256 256"
                        />
                    </FlexChild>
                )}

                <Text as="p" variant="text5" color="gray">
                    {isMobile ? __('quests_redeem_app_qr_modal_description') : __('quests_redeem_qr_modal_description')}
                </Text>

                <Button fullWidth onClick={() => (isMobile ? window.open(deepLinkUrl) : setOpenQRModal(false))}>
                    {isMobile ? __('open_app_button_title') : __('settings_manage_subscription_ok')}
                </Button>
            </FlexWrapper>
        </Modal>
    );
};

export default QRPopup;
